<script setup lang="ts">
import {
  useAllVisibility,
  useDefaultAvatar,
  usePreviewImg,
} from "@/use/common";
import { Image, TextEllipsis } from "vant";
import { computed } from "vue";
import { getDisplayDateTime } from "@/modules/common";
import i18n from "@/locales";
import { StoryBook } from "@/types/entity";

const props = defineProps<{
  storyBook: StoryBook;
}>();

const isGenerating = computed(() => {
  return !props.storyBook.description;
});
const VISIBILITIES = useAllVisibility();
const visibilityText = computed(() => {
  return VISIBILITIES.find((v) => v.value === props.storyBook.visibility)?.text;
});
</script>
<template>
  <div class="flex py-2 h-28 gap-4">
    <div class="h-full aspect-[1/1] relative">
      <Image
        :src="
          storyBook.media
            ? usePreviewImg(storyBook.media.url)
            : useDefaultAvatar()
        "
        class="h-full aspect-[1/1] object-cover"
        :class="{ 'bg-primary': true }"
        fit="cover"
        crossorigin="anonymous"
      />
      <div
        v-if="!storyBook.dtPublish || isGenerating"
        class="absolute right-0 top-1 badge"
      >
        {{
          isGenerating
            ? i18n.global.t("story.processing")
            : i18n.global.t("story.draft")
        }}
      </div>
      <div
        class="absolute right-0 top-1 badge badge-primary"
        v-else-if="storyBook.visibility !== 1"
      >
        {{ visibilityText }}
      </div>
    </div>
    <div class="flex flex-col flex-grow gap-1 h-full overflow-hidden">
      <div class="text-base">
        {{ storyBook.title }}
      </div>
      <text-ellipsis
        class="text-base-content/50"
        rows="3"
        :content="
          isGenerating ? $t('story.generateTimeMinutes') : storyBook.description
        "
      />
      <div v-if="isGenerating" class="text-base-content/50">
        {{ $t("story.generateTime") }}
        ：
        {{ getDisplayDateTime(storyBook.dtCreate!) }}
      </div>
    </div>
  </div>
</template>
